import { OcsEventDispatcher } from 'common/js/OCSTrackingEvent';
import { FormatContext, ILoadingStrategy } from '../loading-strategy-factory';
import eventBus from 'common/event-handling/event-bus.model';
import { isOCSCreative } from 'common/js/format-helper';

import { OcsPreloadedEvent } from '../../event-handling/ocs-preloaded-event';

export class OcsLoadingStrategy implements ILoadingStrategy {
  isRunnable(formatContext: any): boolean {
    return isOCSCreative(formatContext.config);
  }

  alterConfiguration(formatContext: FormatContext): FormatContext {
    // Do not try to calculate the size of the Celtra / Motionly creative within the iframe
    formatContext.config = {
      ...formatContext.config,
      forceResponsiveHtml: true,
      redirectType: formatContext.config.redirectType || 'ocs'
    };

    return formatContext;
  }

  onBeforeRender(formatContext: FormatContext): void {
    OcsEventDispatcher.getInstance().addEventListener('loaded', () => {
      this.onOcsLoaded();
    });
  }

  onAfterRender(formatContext: FormatContext): void {}

  private onOcsLoaded(): void {
    eventBus.publish(new OcsPreloadedEvent());
  }

  onResize(formatContext: FormatContext): void {}
}
